export default function MessageGroup({ successMessage, errorMessage }: {
    successMessage: any,
    errorMessage: any
}) {
    return (
        <div>
            {successMessage && <p className="mt-1 text-sm text-green-600">{successMessage}</p>}
            {errorMessage && <p className="mt-1 text-sm text-red-600">{errorMessage}</p>}
        </div>
    )
}